<nz-spin [nzSpinning]="loading">
  <form nz-form nzLayout="vertical" [formGroup]="form" (ngSubmit)="submitForm()">
    <nz-row [nzGutter]="16">
      <nz-col [nzXs]="24" [nzMd]="12">
        <nz-form-item>
          <nz-form-label nzFor="originStoreId" nzRequired>
            <span>Ursprungslager</span>
          </nz-form-label>
          <nz-form-control [nzErrorTip]="requiredMsg('Ursprungslager')">
            <nz-select
              id="originStoreId"
              formControlName="originStoreId"
              (ngModelChange)="originStoreChanged()"
            >
              @for (store of (storesList$ | async); track store) {
                <nz-option [nzLabel]="store.value" [nzValue]="store.id"></nz-option>
              }
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </nz-col>
      <nz-col [nzXs]="24" [nzMd]="12">
        <nz-form-item>
          <nz-form-label nzFor="targetStoreId" nzRequired>
            <span>Ziellager</span>
          </nz-form-label>
          <nz-form-control [nzErrorTip]="requiredMsg('Ziellager')">
            <nz-select
              id="targetStoreId"
              formControlName="targetStoreId"
              (ngModelChange)="reloadArticles()"
            >
              @for (store of targetStoresList; track store) {
                <nz-option [nzLabel]="store.value" [nzValue]="store.id"></nz-option>
              }
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </nz-col>
      <nz-col [nzXs]="24" [nzMd]="12">
        <nz-form-item>
          <nz-form-label nzFor="worker" nzRequired>
            <span>Mitarbeiter</span>
          </nz-form-label>
          <nz-form-control [nzErrorTip]="requiredMsg('Mitarbeiter')">
            <nz-select id="worker" formControlName="worker">
              @for (user of (usersList$ | async); track user) {
                <nz-option [nzLabel]="user.value" [nzValue]="user.id"></nz-option>
              }
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </nz-col>
      <nz-col [nzXs]="24" [nzMd]="12">
        <nz-form-item>
          <nz-form-label nzFor="deliveryDate" nzRequired>
            <span>Liefertermin</span>
          </nz-form-label>
          <nz-form-control [nzErrorTip]="requiredMsg('Liefertermin')">
            <nz-date-picker
              id="deliveryDate"
              class="full-width"
              [nzFormat]="dateFormat"
              formControlName="deliveryDate"
              [nzDisabledDate]="disableDatesBeforeNow"
            ></nz-date-picker>
          </nz-form-control>
        </nz-form-item>
      </nz-col>
      <nz-col [nzXs]="24" [nzMd]="12">
        <nz-form-item>
          <nz-form-label nzFor="status">
            <span>Status</span>
          </nz-form-label>
          <nz-form-control>
            <nz-select formControlName="status" id="status" nzDisabled>
              @for (type of statusTypes | keyvalue; track type.key) {
                <nz-option [nzLabel]="statusLabels[type.key]" [nzValue]="type.value"></nz-option>
              }
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </nz-col>
      <nz-col [nzXs]="24" [nzMd]="12">
        <nz-form-item>
          <nz-form-label nzFor="isPriority">
            <span>Priorität</span>
          </nz-form-label>
          <nz-form-control>
            <label nz-checkbox formControlName="isPriority" id="isPriority"></label>
          </nz-form-control>
        </nz-form-item>
      </nz-col>
      <nz-col [nzSpan]="24">
        <nz-form-item>
          <nz-form-label nzFor="comment">
            <span>Kommentar</span>
          </nz-form-label>
          <nz-form-control>
            <textarea
              nz-input
              id="comment"
              formControlName="comment"
              [nzAutosize]="{ minRows: 3, maxRows: 8 }"
            ></textarea>
          </nz-form-control>
        </nz-form-item>
      </nz-col>
    </nz-row>

    @if (!editObject && form.get('status').value === statusTypes.Open) {
      <button
        (click)="addVariant()"
        nz-button
        nzType="primary"
        type="button"
        id="add-product-row"
        [disabled]="!form.get('originStoreId').value || !form.get('targetStoreId').value"
      >Neuen Artikel hinzufügen</button>
    }

    <nz-table
      nzBordered
      [nzData]="stockTransferArticleVariants"
      [nzShowPagination]="false"
      [nzNoResult]="emptyArticlesTpl"
    >
      <thead>
        <tr>
          <th>Artikelname</th>
          <th>Variantenname</th>
          <th>EAN</th>
          <th>Lagerbestand im Ursprung</th>
          <th>Umlagerungsmenge</th>
          <th>Lagerbestand im Ziel</th>
          @if (form.get('status').value === statusTypes.Open) {
            <th></th>
          }
        </tr>
      </thead>
      <tbody>
        @for (el of stockTransferArticleVariants; track el; let i = $index) {
          <tr (click)="startEdit(i)" class="editable-row">
            @if (!el.isNew) {
              <td>
                {{ el.articleName }}
              </td>
              <td>{{ el.articleVariantName }}</td>
              <td>
                {{ el.ean }}
              </td>
              <td>
                {{form.controls.originStoreId.value ? el.originInStock : '–' }}
              </td>
              <td>
                @if (editedRowId !== i) {
                  {{ el.quantity }}
                }
                @if (editedRowId === i) {
                  <input
                    nz-input
                    type="number"
                    [attr.aria-label]="'Umlagerungsmenge'"
                    [value]="el.quantity"
                    min="0"
                    #inputElement
                    (change)="quantityChanged(inputElement)"
                    >
                }
              </td>
              <td>
                {{ el.targetInStock }}
              </td>
            }
            @if (el.isNew) {
              <td>{{ el.articleName }}</td>
              <td>{{ el.articleVariantName }}</td>
              <td>
                <div class="d-flex align-items-center" style="gap: 8px;">
                  <input
                    type="text"
                    nz-input
                    placeholder="EAN"
                    [attr.aria-label]="'EAN'"
                    #eanInputRef
                    (ngModelChange)="eanChanged($event, i, false)"
                    [(ngModel)]="el.ean"
                    [ngModelOptions]="{ standalone: true }"
                    >
                  <button
                    type="button"
                    nz-button
                    nzType="primary"
                    (click)="eanChanged(el.ean, i, true)"
                    aria-label="EAN prüfen"
                    style="min-width: 32px; max-width: 32px;"
                    >
                    <i
                      nz-icon
                      nzType="check"
                      nzTheme="outline"
                      nz-tooltip
                      nzTooltipTitle="EAN prüfen"
                    ></i>
                  </button>
                </div>
              </td>
              <td>
                {{form.controls.originStoreId.value ? el.originInStock : '–' }}
              </td>
              <td>
                @if (editedRowId !== i) {
                  {{ el.quantity }}
                }
                @if (editedRowId === i) {
                  <input
                    nz-input
                    type="number"
                    [attr.aria-label]="'Umlagerungsmenge'"
                    [value]="el.quantity"
                    min="0"
                    #inputElement
                    (change)="quantityChanged(inputElement)"
                    >
                }
              </td>
              <td>
                {{ form.controls.targetStoreId.value ? el.targetInStock : '–' }}
              </td>
            }
            @if (form.get('status').value === statusTypes.Open) {
              <td>
                <i
                  style="cursor: pointer;"
                  nz-icon nzType="delete"
                  nz-popconfirm
                  nzPopconfirmTitle="Sind Sie sicher?"
                  (nzOnConfirm)="removeRow(i)"
                  (click)="$event.stopPropagation();"
                  nzTheme="twotone"
                  [nzTwotoneColor]="'#eb2f96'"
                  nz-tooltip
                  nzTooltipTitle="Zeile entfernen"
                ></i>
              </td>
            }
          </tr>
        }
      </tbody>
    </nz-table>
  </form>
</nz-spin>

<ng-template #emptyArticlesTpl>
  Noch keine Artikel — über Neuen Artikel hinzufügen ergänzen
</ng-template>
